(function () {
  'use strict';

  function initHeader() {
    var h = document.querySelector('[data-una-header]');
    if (!h) return;
    window.addEventListener('scroll', function () {
      h.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });
    initNavDropdowns(h);
  }

  function initNavDropdowns(header) {
    if (!header || !window.matchMedia('(min-width: 1024px)').matches) return;

    header.querySelectorAll('.una-header__drop').forEach(function (drop) {
      var panel = drop.querySelector('[data-una-drop-panel]');
      if (!panel) return;

      var img = panel.querySelector('[data-una-drop-media-img]');
      var mediaLink = panel.querySelector('[data-una-drop-media-link]');
      var defaultSrc = img ? img.getAttribute('src') : '';
      var defaultHref = mediaLink ? mediaLink.getAttribute('href') : '';

      drop.querySelectorAll('[data-una-drop-image]').forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          var src = link.getAttribute('data-una-drop-image');
          if (src && img) {
            img.src = src;
            if (mediaLink) mediaLink.hidden = false;
          }
          if (mediaLink) mediaLink.href = link.href;
        });
      });

      drop.addEventListener('mouseleave', function () {
        if (img && defaultSrc) img.src = defaultSrc;
        if (mediaLink && defaultHref) mediaLink.href = defaultHref;
      });

      drop.addEventListener('toggle', function () {
        if (!drop.open) return;
        header.querySelectorAll('.una-header__drop[open]').forEach(function (other) {
          if (other !== drop) other.open = false;
        });
      });
    });
  }

  function initMobileNav() {
    var drawer = document.querySelector('[data-una-nav-drawer]');
    var openBtn = document.querySelector('[data-una-menu-open]');
    if (!drawer || !openBtn) return;

    function openMenu() {
      drawer.hidden = false;
      document.body.classList.add('una-nav-open');
      openBtn.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      drawer.hidden = true;
      document.body.classList.remove('una-nav-open');
      openBtn.setAttribute('aria-expanded', 'false');
    }

    openBtn.addEventListener('click', openMenu);
    drawer.querySelectorAll('[data-una-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });
    drawer.querySelectorAll('.una-nav-drawer__links a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeMenu();
    });
  }

  function initThumbs() {
    document.querySelectorAll('.una-catgrid__thumbs').forEach(function (group) {
      group.querySelectorAll('.una-catgrid__thumb').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.una-catgrid__thumb').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });
  }

  function initProductSliders(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-una-slider]').forEach(function (slider) {
      if (slider.hasAttribute('data-una-slider-init')) return;
      if (slider.hasAttribute('data-una-slider-desktop') && window.matchMedia('(max-width: 900px)').matches) {
        return;
      }

      var track = slider.querySelector('[data-una-slider-track]');
      var bar = slider.querySelector('[data-una-slider-progress]');
      var wrap = slider.querySelector('[data-una-slider-progress-wrap]');
      if (!track) return;
      slider.setAttribute('data-una-slider-init', '');

      var active = false;
      var moved = false;
      var mode = null;
      var startX = 0;
      var startY = 0;
      var startScroll = 0;
      var lastX = 0;
      var lastT = 0;
      var velocity = 0;
      var inertiaId = null;

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function clampScroll(left) {
        return Math.max(0, Math.min(left, maxScroll()));
      }

      function updateProgress() {
        if (!bar || !wrap) return;
        var max = maxScroll();
        if (max <= 1) {
          wrap.classList.add('is-static');
          bar.style.width = '100%';
          bar.style.transform = 'translateX(0)';
          return;
        }
        wrap.classList.remove('is-static');
        var thumb = (track.clientWidth / track.scrollWidth) * 100;
        var ratio = track.scrollLeft / max;
        bar.style.width = thumb + '%';
        bar.style.transform = 'translateX(' + (ratio * (100 - thumb) / thumb * 100) + '%)';
      }

      if (slider.closest('[data-una-cart-drawer]') && window.matchMedia('(max-width: 767px)').matches) {
        track.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress);
        updateProgress();
        return;
      }

      function stopInertia() {
        if (inertiaId) {
          cancelAnimationFrame(inertiaId);
          inertiaId = null;
        }
      }

      function runInertia() {
        if (Math.abs(velocity) < 0.25) {
          inertiaId = null;
          return;
        }
        var next = clampScroll(track.scrollLeft - velocity);
        if (next !== track.scrollLeft) {
          track.scrollLeft = next;
          updateProgress();
        } else {
          velocity *= 0.4;
        }
        velocity *= 0.94;
        inertiaId = requestAnimationFrame(runInertia);
      }

      function beginDrag(x, y, inputMode) {
        stopInertia();
        active = true;
        moved = false;
        mode = inputMode;
        startX = lastX = x;
        startY = y;
        startScroll = track.scrollLeft;
        lastT = performance.now();
        velocity = 0;
      }

      function dragTo(x, y, e) {
        if (!active) return;
        var dx = x - startX;
        var dy = y - startY;

        if (!moved) {
          if (mode === 'touch' && Math.abs(dy) > Math.abs(dx)) return;
          if (Math.abs(dx) < 3) return;
          moved = true;
          track.classList.add('is-dragging');
        }

        if (e && e.cancelable) e.preventDefault();

        var now = performance.now();
        var dt = now - lastT;
        if (dt > 0) velocity = (x - lastX) / dt * 16;
        lastX = x;
        lastT = now;

        track.scrollLeft = clampScroll(startScroll - dx);
        updateProgress();
      }

      function finishDrag() {
        if (!active) return;
        active = false;
        mode = null;
        track.classList.remove('is-dragging');
        if (moved && Math.abs(velocity) > 0.5) runInertia();
        if (moved) window.setTimeout(function () { moved = false; }, 10);
      }

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        e.preventDefault();
        beginDrag(e.clientX, e.clientY, 'mouse');
      });

      window.addEventListener('mousemove', function (e) {
        if (!active || mode !== 'mouse') return;
        dragTo(e.clientX, e.clientY, e);
      });

      window.addEventListener('mouseup', function () {
        if (mode === 'mouse') finishDrag();
      });

      track.addEventListener('touchstart', function (e) {
        if (!e.touches.length) return;
        var t = e.touches[0];
        beginDrag(t.clientX, t.clientY, 'touch');
      }, { passive: true });

      window.addEventListener('touchmove', function (e) {
        if (!active || mode !== 'touch' || !e.touches.length) return;
        dragTo(e.touches[0].clientX, e.touches[0].clientY, e);
      }, { passive: false });

      window.addEventListener('touchend', function () {
        if (mode === 'touch') finishDrag();
      });

      window.addEventListener('touchcancel', function () {
        if (mode === 'touch') finishDrag();
      });

      track.addEventListener('click', function (e) {
        if (!moved) return;
        var link = e.target.closest('a');
        if (link) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      track.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    });
  }

  function initProductGallery() {
    document.querySelectorAll('[data-una-gallery]').forEach(function (gallery) {
      var thumbsWrap = gallery.querySelector('[data-una-gallery-thumbs]');
      var thumbs = gallery.querySelectorAll('[data-una-gallery-thumb]');
      var items = gallery.querySelectorAll('[data-una-gallery-item]');
      var zoomBtn = gallery.querySelector('[data-una-gallery-zoom]');
      var expandBtn = gallery.querySelector('[data-una-gallery-expand]');

      function scrollThumbIntoView(thumb) {
        if (!thumbsWrap || !thumb) return;
        thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.getAttribute('data-media-id');
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          items.forEach(function (item) {
            item.classList.toggle('is-active', item.getAttribute('data-media-id') === id);
          });
          thumb.classList.add('is-active');
          scrollThumbIntoView(thumb);
        });
      });

      var activeThumb = gallery.querySelector('[data-una-gallery-thumb].is-active');
      if (activeThumb) scrollThumbIntoView(activeThumb);

      function syncThumbHeight() {
        if (!thumbsWrap) return;
        var dir = window.getComputedStyle(thumbsWrap).flexDirection;
        if (dir !== 'column') {
          thumbsWrap.style.height = '';
          return;
        }
        var main = gallery.querySelector('[data-una-gallery-main]');
        if (!main) return;
        thumbsWrap.style.height = main.offsetHeight + 'px';
      }
      syncThumbHeight();
      window.addEventListener('resize', syncThumbHeight);
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(syncThumbHeight);
        var mainEl = gallery.querySelector('[data-una-gallery-main]');
        if (mainEl) ro.observe(mainEl);
      }

      if (zoomBtn) {
        zoomBtn.addEventListener('click', function () {
          var active = gallery.querySelector('[data-una-gallery-item].is-active img[data-una-gallery-image]');
          if (!active) return;
          active.style.transform = active.style.transform ? '' : 'scale(1.5)';
          active.style.transition = 'transform 0.3s ease';
          active.style.cursor = active.style.transform ? 'zoom-out' : 'zoom-in';
        });
      }

      if (expandBtn) {
        expandBtn.addEventListener('click', function () {
          var active = gallery.querySelector('[data-una-gallery-item].is-active img[data-una-gallery-image]');
          if (active && active.requestFullscreen) active.requestFullscreen();
        });
      }
    });
  }

  function initProductVariants() {
    document.querySelectorAll('[data-una-product]').forEach(function (section) {
      var jsonEl = section.querySelector('[data-una-product-json]');
      var form = section.querySelector('[data-una-product-form]');
      if (!jsonEl || !form) return;

      var product = JSON.parse(jsonEl.textContent);
      var variantInput = form.querySelector('[data-una-variant-id]');
      var priceEl = section.querySelector('[data-una-price]');
      var atcBtn = form.querySelector('[data-una-atc]');
      var colorLabel = section.querySelector('[data-una-color-label]');
      var sizeLabel = section.querySelector('[data-una-size-label]');
      var selected = {};

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function activateGalleryMedia(mediaId) {
        if (!mediaId) return false;
       var gallery = section.querySelector('[data-una-gallery]');
        if (!gallery) return false;

       var id = String(mediaId);
       var mainWrap = gallery.querySelector('[data-una-gallery-main]');
       var thumbsWrap = gallery.querySelector('[data-una-gallery-thumbs]');
       var items = Array.from(gallery.querySelectorAll('[data-una-gallery-item]'));
       var thumbs = Array.from(gallery.querySelectorAll('[data-una-gallery-thumb]'));
       var found = false;

        // 重新排序 main items：目标图片移到首位，其余紧随其后
       var matchedItems = items.filter(function (el) { return el.getAttribute('data-media-id') === id; });
       var otherItems = items.filter(function (el) { return el.getAttribute('data-media-id') !== id; });
       matchedItems.concat(otherItems).forEach(function (el) { mainWrap.appendChild(el); });

       // 重新排序 thumbs：目标缩略图移到首位
       if (thumbsWrap) {
       var matchedThumbs = thumbs.filter(function (el) { return el.getAttribute('data-media-id') === id; });
       var otherThumbs = thumbs.filter(function (el) { return el.getAttribute('data-media-id') !== id; });
       matchedThumbs.concat(otherThumbs).forEach(function (el) { thumbsWrap.appendChild(el); });
       }

       // 激活第一个
       var allItems = Array.from(gallery.querySelectorAll('[data-una-gallery-item]'));
       var allThumbs = Array.from(gallery.querySelectorAll('[data-una-gallery-thumb]'));
       allItems.forEach(function (el) { el.classList.remove('is-active'); });
       allThumbs.forEach(function (el) { el.classList.remove('is-active'); });
       if (allItems[0]) { allItems[0].classList.add('is-active'); found = true; }
       if (allThumbs[0]) {
       allThumbs[0].classList.add('is-active');
       allThumbs[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
       } 

        return found;
      }

      function filterGalleryByColor(colorValue) {
       if (!colorValue) return;
       var gallery = section.querySelector('[data-una-gallery]');
       if (!gallery) return;

       var colorNorm = String(colorValue).toLowerCase().replace(/[\s_-]+/g, '');
       var items = Array.from(gallery.querySelectorAll('[data-una-gallery-item]'));
       var thumbs = Array.from(gallery.querySelectorAll('[data-una-gallery-thumb]'));

       items.forEach(function (el) {
        var img = el.querySelector('img');
        var alt = img ? (img.getAttribute('alt') || '').toLowerCase().replace(/[\s_-]+/g, '') : '';
        el.style.display = alt.indexOf(colorNorm) >= 0 ? '' : 'none';
       });

       thumbs.forEach(function (el) {
        var img = el.querySelector('img');
        var alt = img ? (img.getAttribute('alt') || '').toLowerCase().replace(/[\s_-]+/g, '') : '';
        el.style.display = alt.indexOf(colorNorm) >= 0 ? '' : 'none';
       });
      }
      function altMatchesColor(alt, colorValue) {
        if (!alt || !colorValue) return false;
        var altNorm = String(alt).toLowerCase().replace(/[\s_-]+/g, '');
        var colorNorm = String(colorValue).toLowerCase().replace(/[\s_-]+/g, '');
        return altNorm.indexOf('color' + colorNorm) >= 0;
      }

      function showGalleryForColor(colorValue) {
        filterGalleryByColor(colorValue);
        if (!colorValue) return false;
        var gallery = section.querySelector('[data-una-gallery]');
        if (!gallery) return false;
        var items = gallery.querySelectorAll('[data-una-gallery-item]');

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          var img = item.querySelector('img');
          var alt = img ? img.getAttribute('alt') || '' : '';
          if (altMatchesColor(alt, colorValue)) {
            return activateGalleryMedia(item.getAttribute('data-media-id'));
          }
        }
        return false;
      }

      function getVariantColorValue(variant) {
        var options = product.options || [];
        for (var i = 0; i < options.length; i++) {
          var name = String(options[i] || '').toLowerCase();
          if (name.indexOf('color') >= 0 || name.indexOf('colour') >= 0) {
            return variant['option' + (i + 1)];
          }
        }
        return variant.option1;
      }

      function showGalleryForVariant(variant) {
        if (!variant) return;

        if (variant.featured_media && variant.featured_media.id) {
          if (activateGalleryMedia(variant.featured_media.id)) return;
        }

        showGalleryForColor(getVariantColorValue(variant));
      }

      form.querySelectorAll('[data-una-option]').forEach(function (btn) {
        var key = btn.getAttribute('data-una-option');
        if (!selected[key]) selected[key] = btn.getAttribute('data-value');
        btn.addEventListener('click', function () {
          selected[key] = btn.getAttribute('data-value');
          form.querySelectorAll('[data-una-option="' + key + '"]').forEach(function (b) {
            var on = b.getAttribute('data-value') === selected[key];
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (key.indexOf('option') === 0 && colorLabel && btn.classList.contains('una-pdp__swatch')) {
            colorLabel.textContent = selected[key];
            showGalleryForColor(selected[key]);
          }
          if (key.indexOf('option') === 0 && sizeLabel && btn.classList.contains('una-pdp__size')) {
            sizeLabel.textContent = selected[key];
          }
          updateVariant();
        });
      });

      function updateVariant() {
        var match = product.variants.find(function (v) {
          return (!selected.option1 || v.option1 === selected.option1)
            && (!selected.option2 || v.option2 === selected.option2)
            && (!selected.option3 || v.option3 === selected.option3);
        });
        if (!match) return;
        variantInput.value = match.id;
        variantInput.disabled = false;
        if (priceEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            priceEl.innerHTML = '<s class="una-pdp__compare">' + formatMoney(match.compare_at_price) + '</s> ' + formatMoney(match.price);
          } else {
            priceEl.textContent = formatMoney(match.price);
          }
        }
        if (atcBtn) {
          atcBtn.disabled = !match.available;
          atcBtn.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT';
        }
        showGalleryForVariant(match);
        section.dispatchEvent(new CustomEvent('una:variant-change', {
          bubbles: true,
          detail: { variant: match, price: match.price }
        }));
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      var currentId = parseInt(variantInput.value, 10);
      var current = product.variants.find(function (v) { return v.id === currentId; });
      if (current) {
        if (current.option1) selected.option1 = current.option1;
        if (current.option2) selected.option2 = current.option2;
        if (current.option3) selected.option3 = current.option3;
      }
    });
  }

  function initShare() {
    document.querySelectorAll('[data-una-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href });
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href);
        }
      });
    });
  }

  function initLaunchCountdown() {
    document.querySelectorAll('[data-una-countdown]').forEach(function (el) {
      var dateStr = el.getAttribute('data-launch-date');
      if (!dateStr) return;
      var target = new Date(dateStr).getTime();
      if (isNaN(target)) return;

      var daysEl = el.querySelector('[data-una-cd-days]');
      var hoursEl = el.querySelector('[data-una-cd-hours]');
      var minsEl = el.querySelector('[data-una-cd-mins]');
      var secsEl = el.querySelector('[data-una-cd-secs]');

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minsEl) minsEl.textContent = '00';
          if (secsEl) secsEl.textContent = '00';
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (daysEl) daysEl.textContent = pad(d);
        if (hoursEl) hoursEl.textContent = pad(h);
        if (minsEl) minsEl.textContent = pad(m);
        if (secsEl) secsEl.textContent = pad(s);
      }

      tick();
      window.setInterval(tick, 1000);
    });
  }

  function initCardSwatches() {
    if (document.documentElement.hasAttribute('data-una-card-swatches-bound')) return;
    document.documentElement.setAttribute('data-una-card-swatches-bound', '');

    function activateSwatch(btn) {
      var group = btn.closest('.una-card-swatches');
      var card = btn.closest('.una-shop-card, .una-showcase-card, .una-product-card');
      if (!group || !card) return;

      var img = card.querySelector('.una-shop-card__media img, .una-showcase-card__media img, .una-product-card__img img');
      var useCrop = card.classList.contains('una-shop-card') || card.classList.contains('una-showcase-card');
      var src = useCrop
        ? (btn.getAttribute('data-una-card-image-crop') || btn.getAttribute('data-una-card-image'))
        : btn.getAttribute('data-una-card-image');
      var srcset = btn.getAttribute('data-una-card-srcset');

      if (img && src) {
        img.removeAttribute('srcset');
        img.src = src;
        if (!useCrop && srcset) {
          img.setAttribute('srcset', srcset);
        }
      }

      group.querySelectorAll('.una-card-swatch').forEach(function (other) {
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.una-card-swatch');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      activateSwatch(btn);
    });

    document.addEventListener('mousedown', function (e) {
      if (e.target.closest('.una-card-swatch')) e.stopPropagation();
    }, true);

    document.addEventListener('touchstart', function (e) {
      if (e.target.closest('.una-card-swatch')) e.stopPropagation();
    }, true);
  }

  function initCollectionInfiniteScroll() {
    if (typeof IntersectionObserver === 'undefined') return;

    document.querySelectorAll('.una-collection').forEach(function (section) {
      var grid = section.querySelector('[data-una-collection-grid], .una-collection__grid');
      if (!grid) return;

      var pagination = section.querySelector('.una-collection__pagination');
      var trigger = section.querySelector('[data-una-collection-infinite]');
      var statusEl;

      if (!trigger) {
        trigger = document.createElement('div');
        trigger.className = 'una-collection__infinite';
        trigger.setAttribute('data-una-collection-infinite', '');
        trigger.innerHTML = '<span class="una-collection__infinite-status" data-una-collection-infinite-status aria-live="polite"></span>';
        if (pagination) {
          pagination.parentNode.insertBefore(trigger, pagination);
        } else {
          grid.parentNode.appendChild(trigger);
        }
      }

      statusEl = trigger.querySelector('[data-una-collection-infinite-status]');

      if (pagination) {
        pagination.hidden = true;
        pagination.setAttribute('aria-hidden', 'true');
      }

      var loading = false;
      var observer = null;

      function withPreviewUrl(url) {
        if (!url) return '';
        var previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (!previewId) return url;
        var next = new URL(url, window.location.origin);
        if (!next.searchParams.has('preview_theme_id')) {
          next.searchParams.set('preview_theme_id', previewId);
        }
        return next.toString();
      }

      function readNextUrl(source) {
        if (!source) return '';
        var infinite = source.querySelector('[data-una-collection-infinite]');
        if (infinite && infinite.getAttribute('data-next-url')) {
          return infinite.getAttribute('data-next-url');
        }
        var nextLink = source.querySelector('.una-collection__pagination a.una-collection__page--arrow[aria-label="Next page"]');
        return nextLink ? nextLink.getAttribute('href') : '';
      }

      function setLoading(isLoading) {
        trigger.classList.toggle('is-loading', isLoading);
        if (statusEl) statusEl.textContent = isLoading ? 'Loading' : '';
      }

      function getNextUrl() {
        return withPreviewUrl(trigger.getAttribute('data-next-url') || readNextUrl(section));
      }

      var initialNext = readNextUrl(section);
      if (!initialNext) {
        trigger.hidden = true;
        return;
      }
      trigger.setAttribute('data-next-url', initialNext);
      trigger.hidden = false;

      function loadNext() {
        var nextUrl = getNextUrl();
        if (!nextUrl || loading) return;

        loading = true;
        setLoading(true);

        fetch(nextUrl, { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to load products');
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('[data-una-collection-grid] .una-collection__item, .una-collection__grid .una-collection__item').forEach(function (item) {
              grid.appendChild(document.importNode(item, true));
            });

            var newNextUrl = readNextUrl(doc);
            if (newNextUrl) {
              trigger.setAttribute('data-next-url', newNextUrl);
              loading = false;
              setLoading(false);
              if (observer) observer.observe(trigger);
            } else {
              trigger.removeAttribute('data-next-url');
              trigger.hidden = true;
              loading = false;
              setLoading(false);
              if (observer) observer.disconnect();
            }
          })
          .catch(function () {
            loading = false;
            setLoading(false);
            if (observer) observer.observe(trigger);
          });
      }

      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(trigger);
          loadNext();
        });
      }, { rootMargin: '480px 0px 240px 0px' });

      observer.observe(trigger);
    });
  }

  function initCartPage() {
    var page = document.querySelector('[data-una-cart-page]');
    if (!page) return;

    var itemsEl = page.querySelector('[data-una-cart-items]');
    if (!itemsEl) return;

    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function changeLine(key, quantity) {
      return fetch(cartRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (res) {
        if (!res.ok) throw new Error('Change failed');
        return res.json();
      }).then(function () {
        window.location.reload();
      });
    }

    itemsEl.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var qtyEl = line.querySelector('[data-una-cart-qty]');
      var qty = parseInt(qtyEl.textContent, 10) || 1;

      if (e.target.closest('[data-una-cart-qty-minus]')) {
        changeLine(key, qty - 1);
      } else if (e.target.closest('[data-una-cart-qty-plus]')) {
        changeLine(key, qty + 1);
      } else if (e.target.closest('[data-una-cart-remove]')) {
        changeLine(key, 0);
      }
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-una-cart-drawer]');
    if (!drawer) return;

    var itemsEl = drawer.querySelector('[data-una-cart-items]');
    var emptyEl = drawer.querySelector('[data-una-cart-empty]');
    var footEl = drawer.querySelector('[data-una-cart-foot]');
    var subtotalEl = drawer.querySelector('[data-una-cart-subtotal]');
    var qtyBreaksWrap = drawer.querySelector('[data-una-cart-qty-breaks-wrap]');
    var qtyBreaksOptionsEl = drawer.querySelector('[data-una-cart-qty-breaks-options]');
    var qtyBreaksConfigEl = document.querySelector('[data-una-cart-qty-breaks-config]');
    var qtyBreaksConfig = { enabled: true, tiers: [] };
    var activeQtyLineKey = null;
    var cartScrollY = 0;

    if (qtyBreaksConfigEl) {
      try {
        qtyBreaksConfig = JSON.parse(qtyBreaksConfigEl.textContent || '{}');
      } catch (err) {
        qtyBreaksConfig = { enabled: true, tiers: [] };
      }
    }

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function tierMatchesQty(tier, qty) {
      if (qty < tier.min_qty) return false;
      if (tier.max_qty > 0 && qty > tier.max_qty) return false;
      return true;
    }

    function getActiveTierIndex(tiers, qty) {
      var activeIndex = -1;
      tiers.forEach(function (tier, index) {
        if (tierMatchesQty(tier, qty)) activeIndex = index;
      });
      return activeIndex;
    }

    function renderQtyBreakOption(tier, index, unitPrice, isActive) {
      var discount = tier.discount_percent || 0;
      var discountedUnit = Math.round(unitPrice * (100 - discount) / 100);
      var offLabel = tier.subtitle || ('Get ' + discount + '% off');
      var label = tier.title + ' · ' + offLabel;

      return (
        '<button type="button" class="una-cart-drawer__tier' + (isActive ? ' is-active' : '') + '" data-una-cart-qty-tier data-cart-qty="' + tier.min_qty + '" data-tier-index="' + index + '">' +
          '<span class="una-cart-drawer__tier-main">' + escapeHtml(label) + '</span>' +
          '<span class="una-cart-drawer__tier-price">' + formatMoney(discountedUnit) + ' each</span>' +
        '</button>'
      );
    }

    function renderCartQtyBreaks(cart) {
      if (!qtyBreaksWrap || !qtyBreaksOptionsEl || !qtyBreaksConfig.enabled) {
        return;
      }

      var tiers = qtyBreaksConfig.tiers || [];
      if (!cart.items || cart.items.length === 0 || !tiers.length) {
        qtyBreaksWrap.hidden = true;
        qtyBreaksOptionsEl.innerHTML = '';
        activeQtyLineKey = null;
        return;
      }

      var item = cart.items[0];
      activeQtyLineKey = item.key;
      var unitPrice = item.final_price || item.price || 0;
      var activeIndex = getActiveTierIndex(tiers, item.quantity);

      qtyBreaksWrap.hidden = false;
      qtyBreaksOptionsEl.innerHTML = tiers.map(function (tier, index) {
        return renderQtyBreakOption(tier, index, unitPrice, index === activeIndex);
      }).join('');
    }

    function updateBadge(count) {
      document.querySelectorAll('.una-header__cart-num, .una-nav-drawer__cart-count').forEach(function (el) {
        el.textContent = count;
      });
    }

    function openDrawer() {
      cartScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = '-' + cartScrollY + 'px';
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('una-cart-open');
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      refreshCart();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('una-cart-open');
      document.body.style.top = '';
      window.scrollTo(0, cartScrollY);
      drawer.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 350);
    }

    function renderCart(cart) {
      updateBadge(cart.item_count);

      if (!cart.items || cart.items.length === 0) {
        emptyEl.hidden = false;
        footEl.hidden = true;
        itemsEl.innerHTML = '';
        renderCartQtyBreaks(cart);
        return;
      }

      emptyEl.hidden = true;
      footEl.hidden = false;
      subtotalEl.textContent = formatMoney(cart.total_price);

      itemsEl.innerHTML = cart.items.map(function (item) {
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="una-cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</span>'
          : '';
        var img = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" width="108" height="135" loading="lazy">'
          : '';
        return (
          '<li class="una-cart-drawer__item" data-line-key="' + escapeHtml(item.key) + '">' +
            '<a href="' + escapeHtml(item.url) + '" class="una-cart-drawer__item-img">' + img + '</a>' +
            '<div class="una-cart-drawer__item-info">' +
              '<a href="' + escapeHtml(item.url) + '" class="una-cart-drawer__item-name">' + escapeHtml(item.product_title) + '</a>' +
              variantTitle +
              '<div class="una-cart-drawer__qty">' +
                '<button type="button" data-una-cart-qty-minus aria-label="Decrease quantity"' + (item.quantity <= 1 ? ' disabled' : '') + '>-</button>' +
                '<span data-una-cart-qty>' + item.quantity + '</span>' +
                '<button type="button" data-una-cart-qty-plus aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="una-cart-drawer__item-side">' +
              '<span class="una-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
              '<button type="button" class="una-cart-drawer__remove" data-una-cart-remove>Remove</button>' +
            '</div>' +
          '</li>'
        );
      }).join('');

      renderCartQtyBreaks(cart);
    }

    function refreshCart() {
      return fetch(cartRoot + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(renderCart)
        .catch(function () {});
    }

    function changeLine(key, quantity) {
      return fetch(cartRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Change failed');
          return res.json();
        })
        .then(renderCart);
    }

    function addToCart(payload) {
      return fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error((data && data.description) || 'Add failed');
            });
          }
          return res.json();
        });
    }

    document.querySelectorAll('[data-una-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    drawer.querySelectorAll('[data-una-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    var viewCartLink = drawer.querySelector('.una-cart-drawer__view');
    if (viewCartLink) {
      viewCartLink.addEventListener('click', function (e) {
        var previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (!previewId) return;
        var target = new URL(viewCartLink.getAttribute('href'), window.location.origin);
        if (target.searchParams.get('preview_theme_id') === previewId) return;
        e.preventDefault();
        target.searchParams.set('preview_theme_id', previewId);
        window.location.assign(target.toString());
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    itemsEl.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var qtyEl = line.querySelector('[data-una-cart-qty]');
      var qty = parseInt(qtyEl.textContent, 10) || 1;

      if (e.target.closest('[data-una-cart-qty-minus]')) {
        changeLine(key, qty - 1);
      } else if (e.target.closest('[data-una-cart-qty-plus]')) {
        changeLine(key, qty + 1);
      } else if (e.target.closest('[data-una-cart-remove]')) {
        changeLine(key, 0);
      }
    });

    if (qtyBreaksOptionsEl) {
      qtyBreaksOptionsEl.addEventListener('click', function (e) {
        var option = e.target.closest('[data-una-cart-qty-tier]');
        if (!option || !activeQtyLineKey) return;
        var cartQty = parseInt(option.getAttribute('data-cart-qty'), 10);
        if (!cartQty || cartQty < 1) return;
        changeLine(activeQtyLineKey, cartQty);
      });
    }

    document.querySelectorAll('[data-una-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var atcBtn = form.querySelector('[data-una-atc]');
        var variantInput = form.querySelector('[data-una-variant-id]');
        if (!variantInput || !variantInput.value || variantInput.disabled) return;

        var originalText = atcBtn ? atcBtn.textContent : '';
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding…';
        }

        var qtyInput = form.querySelector('[data-una-qty-input]');
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        addToCart({ items: [{ id: parseInt(variantInput.value, 10), quantity: quantity }] })
          .then(refreshCart)
          .then(openDrawer)
          .then(function () {
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.textContent = originalText;
            }
          })
          .catch(function () {
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.textContent = originalText;
            }
          });
      });
    });

    window.UnaCart = {
      open: openDrawer,
      close: closeDrawer,
      refresh: refreshCart,
      addItems: function (items) {
        return addToCart({ items: items }).then(refreshCart).then(openDrawer);
      }
    };
  }

  function initQtyBreaks() {
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    document.querySelectorAll('[data-una-qty-breaks]').forEach(function (root) {
      var section = root.closest('[data-una-product]');
      if (!section) return;

      var form = section.querySelector('[data-una-product-form]');
      var qtyInput = form ? form.querySelector('[data-una-qty-input]') : null;
      var tiers = root.querySelectorAll('[data-una-qty-tier]');
      if (!tiers.length) return;

      function updateTierPrices(unitPrice) {
        root.setAttribute('data-unit-price', unitPrice);
        tiers.forEach(function (tier) {
          var discount = parseInt(tier.getAttribute('data-discount'), 10) || 0;
          var discounted = Math.round(unitPrice * (100 - discount) / 100);
          var save = unitPrice - discounted;
          var compareEl = tier.querySelector('[data-una-qty-compare]');
          var eachEl = tier.querySelector('[data-una-qty-each]');
          var saveEl = tier.querySelector('[data-una-qty-save]');
          if (compareEl) compareEl.textContent = formatMoney(unitPrice);
          if (eachEl) eachEl.textContent = formatMoney(discounted);
          if (saveEl) saveEl.textContent = 'You save ' + formatMoney(save);
        });
      }

      function selectTier(tier) {
        tiers.forEach(function (item) {
          item.classList.toggle('is-active', item === tier);
        });
        var radio = tier.querySelector('[data-una-qty-tier-input]');
        if (radio) radio.checked = true;
        if (qtyInput) {
          qtyInput.value = tier.getAttribute('data-cart-qty') || tier.getAttribute('data-min-qty') || '1';
        }
      }

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () {
          selectTier(tier);
        });
      });

      var activeTier = root.querySelector('[data-una-qty-tier].is-active') || tiers[0];
      if (activeTier) selectTier(activeTier);

      section.addEventListener('una:variant-change', function (e) {
        if (!e.detail || typeof e.detail.price !== 'number') return;
        updateTierPrices(e.detail.price);
      });

      var initialPrice = parseInt(root.getAttribute('data-unit-price'), 10);
      if (!isNaN(initialPrice)) updateTierPrices(initialPrice);
    });
  }

  function initProductBundle() {
    document.querySelectorAll('[data-una-bundle]').forEach(function (root) {
      var items = root.querySelectorAll('[data-una-bundle-item]');
      var linesEl = root.querySelector('[data-una-bundle-lines]');
      var subtotalEl = root.querySelector('[data-una-bundle-subtotal]');
      var saveRow = root.querySelector('[data-una-bundle-save-row]');
      var saveEl = root.querySelector('[data-una-bundle-save]');
      var totalEl = root.querySelector('[data-una-bundle-total]');
      var hintEl = root.querySelector('[data-una-bundle-hint]');
      var atcBtn = root.querySelector('[data-una-bundle-atc]');
      var statusEl = root.querySelector('[data-una-bundle-status]');
      var discount = parseInt(root.getAttribute('data-discount'), 10) || 0;
      var minItems = parseInt(root.getAttribute('data-min-items'), 10) || 2;

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function getSelectedItems() {
        var selected = [];
        items.forEach(function (item) {
          var check = item.querySelector('[data-una-bundle-check]');
          var isFixed = item.getAttribute('data-fixed') === 'true';
          var isChecked = isFixed || (check && check.checked);
          if (!isChecked) return;
          if (item.getAttribute('data-available') !== 'true') return;
          selected.push({
            item: item,
            variantId: parseInt(item.getAttribute('data-variant-id'), 10),
            price: parseInt(item.getAttribute('data-price'), 10),
            name: item.querySelector('.una-pdp-bundle__card-name').textContent.trim()
          });
        });
        return selected;
      }

      function updateSummary() {
        items.forEach(function (item) {
          var check = item.querySelector('[data-una-bundle-check]');
          var isFixed = item.getAttribute('data-fixed') === 'true';
          var isChecked = isFixed || (check && check.checked);
          item.classList.toggle('is-selected', isChecked);
        });

        var selected = getSelectedItems();
        var subtotal = selected.reduce(function (sum, s) { return sum + s.price; }, 0);
        var hasDiscount = selected.length >= minItems && discount > 0;
        var saveAmount = hasDiscount ? Math.round(subtotal * discount / 100) : 0;
        var total = subtotal - saveAmount;

        if (linesEl) {
          linesEl.innerHTML = selected.map(function (s) {
            return '<li class="una-pdp-bundle__line"><span class="una-pdp-bundle__line-name">' + s.name + '</span><span class="una-pdp-bundle__line-price">' + formatMoney(s.price) + '</span></li>';
          }).join('');
        }
        if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
        if (saveRow) saveRow.hidden = !hasDiscount;
        if (saveEl) saveEl.textContent = hasDiscount ? '-' + formatMoney(saveAmount) : '—';
        if (totalEl) totalEl.textContent = formatMoney(total);
        if (hintEl) {
          hintEl.classList.toggle('is-active', hasDiscount);
          if (hasDiscount) {
            hintEl.textContent = 'You save ' + formatMoney(saveAmount) + ' on this set.';
          }
        }
        if (atcBtn) {
          atcBtn.disabled = selected.length === 0;
          atcBtn.textContent = selected.length > 1
            ? 'Add ' + selected.length + ' items to cart'
            : (atcBtn.getAttribute('data-default-label') || 'Add set to cart');
        }
      }

      if (atcBtn && !atcBtn.getAttribute('data-default-label')) {
        atcBtn.setAttribute('data-default-label', atcBtn.textContent.trim());
      }

      root.querySelectorAll('[data-una-bundle-check]').forEach(function (check) {
        check.addEventListener('change', function () {
          if (statusEl) statusEl.textContent = '';
          updateSummary();
        });
      });

      if (atcBtn) {
        atcBtn.addEventListener('click', function () {
          var selected = getSelectedItems();
          if (!selected.length) return;

          atcBtn.disabled = true;
          if (statusEl) {
            statusEl.textContent = 'Adding…';
            statusEl.className = 'una-pdp-bundle__status';
          }

          var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          fetch(cartRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: selected.map(function (s) {
                return { id: s.variantId, quantity: 1 };
              })
            })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add failed');
              return res.json();
            })
            .then(function () {
              if (statusEl) {
                statusEl.textContent = 'Added to cart!';
                statusEl.className = 'una-pdp-bundle__status is-success';
              }
              if (window.UnaCart) {
                return window.UnaCart.refresh().then(function () {
                  window.UnaCart.open();
                  atcBtn.disabled = false;
                });
              }
              return fetch(cartRoot + 'cart.js');
            })
            .then(function (res) {
              if (!res || !res.json) return;
              return res.json();
            })
            .then(function (cart) {
              if (!cart) return;
              document.querySelectorAll('.una-header__cart-num, .una-nav-drawer__cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
              atcBtn.disabled = false;
            })
            .catch(function () {
              if (statusEl) {
                statusEl.textContent = 'Could not add items. Please try again.';
                statusEl.className = 'una-pdp-bundle__status is-error';
              }
              atcBtn.disabled = false;
            });
        });
      }

      updateSummary();
    });
  }

  function reviewsSectionHasContent(section) {
    if (!section) return false;

    var manualCards = section.querySelectorAll('.una-pdp-review-card');
    if (manualCards.length > 0) return true;

    var judgemeReviews = section.querySelectorAll('.jdgm-rev');
    for (var i = 0; i < judgemeReviews.length; i++) {
      var rev = judgemeReviews[i];
      if (rev.closest('.jdgm-rev-widg__reviews') === null && rev.closest('.jdgm-rev-widg') === null) continue;
      if (rev.querySelector('.jdgm-rev__pics img, .una-jdgm-card .jdgm-rev__pics img, img')) return true;
      if ((rev.textContent || '').replace(/\s+/g, ' ').trim().length > 0) return true;
    }

    return false;
  }

  function fillReviewSummary(el, count, avg) {
    if (!el || !(count > 0) || !(avg > 0)) return;
    var countLabel = count === 1 ? '1 review' : count + ' reviews';
    el.setAttribute('data-review-count', String(count));
    el.innerHTML =
      '<span class="una-pdp-reviews__score">' + avg.toFixed(1) + '</span>' +
      '<span class="una-pdp-reviews__stars" aria-hidden="true">★★★★★</span>' +
      '<span class="una-pdp-reviews__count">' + countLabel + '</span>';
  }

  function syncJudgemeProductSummary() {
    var section = document.querySelector('[data-una-reviews-section]');
    if (!section) return;

    var widg = section.querySelector('.jdgm-rev-widg');
    var n = 0;
    var avg = 0;
    if (widg) {
      n = parseInt(widg.getAttribute('data-number-of-reviews') || '0', 10) || 0;
      avg = parseFloat(widg.getAttribute('data-average-rating') || '0') || 0;
    }

    var cardCount = section.querySelectorAll('.jdgm-rev-widg .jdgm-rev, .jdgm-rev-widg__reviews .jdgm-rev').length;
    if (!n && cardCount) n = cardCount;

    var hasCards = n > 0 || reviewsSectionHasContent(section);
    section.classList.toggle('una-pdp-reviews--has-cards', hasCards);
    section.classList.toggle('una-pdp-reviews--empty', !hasCards);

    var emptyMsg = section.querySelector('.una-pdp-reviews__empty');
    if (emptyMsg) emptyMsg.hidden = hasCards;

    fillReviewSummary(section.querySelector('[data-una-review-summary]'), n, avg);
    fillReviewSummary(document.querySelector('.una-pdp__rating [data-una-review-summary]'), n, avg);
  }

  function syncReviewsSectionVisibility() {
    var section = document.querySelector('[data-una-reviews-section]');
    if (!section) return;

    syncJudgemeProductSummary();
    var hasCards = reviewsSectionHasContent(section) || section.classList.contains('una-pdp-reviews--has-cards');
    var countAttr = parseInt(section.getAttribute('data-product-review-count') || '0', 10) || 0;
    var show = hasCards || countAttr > 0;

    section.hidden = !show;
    if (show) section.removeAttribute('hidden');
    section.setAttribute('aria-hidden', show ? 'false' : 'true');
    section.classList.toggle('una-pdp-reviews--pending', !show);
  }

  function initJudgemeWriteReview() {
    document.querySelectorAll('[data-una-write-review]').forEach(function (btn) {
      if (btn.hasAttribute('data-una-write-init')) return;
      btn.setAttribute('data-una-write-init', '');
      btn.addEventListener('click', function () {
        var nativeBtn = document.querySelector('.una-pdp-reviews .jdgm-write-rev-link, #judgeme_product_reviews .jdgm-write-rev-link');
        if (nativeBtn) nativeBtn.click();
      });
    });
  }

  function forceJudgemeVisible() {
    document.querySelectorAll('.una-pdp-reviews--judgeme, .una-pdp-reviews-apps-wrap').forEach(function (root) {
      root.querySelectorAll('style.jdgm-temp-hiding-style').forEach(function (styleEl) {
        styleEl.remove();
      });
      root.querySelectorAll('.jdgm-prev-badge').forEach(function (badge) {
        badge.style.removeProperty('display');
      });
      root.querySelectorAll('.jdgm-rev-widg').forEach(function (widg) {
        widg.style.removeProperty('display');
      });
    });
  }

  function pullJudgemePagerOut() {
    document.querySelectorAll('.una-pdp-reviews .jdgm-paginate').forEach(function (pager) {
      var slider = pager.closest('[data-una-slider]');
      if (slider && slider.parentNode && pager.parentNode !== slider.parentNode) {
        slider.parentNode.insertBefore(pager, slider.nextSibling);
        return;
      }
      var track = pager.closest('.jdgm-rev-widg__reviews, .una-jdgm-reviews__track');
      if (track && pager.parentNode === track && track.parentNode) {
        var host = track.closest('[data-una-slider]') || track;
        host.parentNode.insertBefore(pager, host.nextSibling);
      }
    });
  }

  function wrapJudgemeReviewTracks() {
    document.querySelectorAll('.una-pdp-reviews-apps-wrap .jdgm-rev-widg__reviews, .una-pdp-reviews--judgeme .jdgm-rev-widg__reviews').forEach(function (track) {
      if (track.closest('[data-una-slider]')) return;

      var slider = document.createElement('div');
      slider.className = 'una-pdp-reviews__slider una-jdgm-reviews-slider';
      slider.setAttribute('data-una-slider', '');

      track.parentNode.insertBefore(slider, track);
      slider.appendChild(track);

      track.classList.add('una-jdgm-reviews__track');
      track.setAttribute('data-una-slider-track', '');
      track.setAttribute('tabindex', '0');
      track.setAttribute('aria-label', 'Customer reviews');

      var progressWrap = document.createElement('div');
      progressWrap.className = 'una-pdp-reviews__progress';
      progressWrap.setAttribute('data-una-slider-progress-wrap', '');
      progressWrap.setAttribute('aria-hidden', 'true');

      var progressBar = document.createElement('div');
      progressBar.className = 'una-pdp-reviews__progress-bar';
      progressBar.setAttribute('data-una-slider-progress', '');
      progressWrap.appendChild(progressBar);
      slider.appendChild(progressWrap);
    });
    pullJudgemePagerOut();
  }

  function hydrateJudgemeReviewPics(root) {
    var scope = root || document;
    scope.querySelectorAll('.una-pdp-reviews .jdgm-rev__pic-img, .una-pdp-reviews .jdgm-rev__pics img').forEach(function (img) {
      var src = img.getAttribute('src');
      var dataSrc = img.getAttribute('data-src') || img.getAttribute('data-lazy-src') || img.getAttribute('data-original');
      if (dataSrc && (!src || src.indexOf('data:') === 0)) {
        img.setAttribute('src', dataSrc);
      }
      img.classList.remove('jdgm--loading');
      var link = img.closest('.jdgm-rev__pic-link');
      if (link) link.classList.remove('jdgm--loading');
    });
  }

  function attachJudgemePics(shell, pics) {
    if (!shell || !pics || !pics.querySelector('img, a, picture')) return;
    hydrateJudgemeReviewPics(pics);
    if (shell.contains(pics)) return;
    var quote = shell.querySelector('.una-jdgm-card__quote');
    if (quote) shell.insertBefore(pics, quote);
    else shell.appendChild(pics);
    shell.classList.add('una-jdgm-card--has-pics');
    var card = shell.closest('.jdgm-rev');
    if (card) card.classList.add('una-jdgm-rev--has-pics');
  }

  function normalizeJudgemeCards() {
    document.querySelectorAll('.una-pdp-reviews-apps-wrap .jdgm-rev, .una-pdp-reviews--judgeme .jdgm-rev').forEach(function (card) {
      var existing = card.querySelector('.una-jdgm-card');
      if (existing) {
        attachJudgemePics(existing, card.querySelector('.jdgm-rev__pics'));
        hydrateJudgemeReviewPics(card);
        return;
      }

      var header = card.querySelector('.jdgm-rev__header');
      var content = card.querySelector('.jdgm-rev__content');
      if (!header || !content) return;

      var rating = header.querySelector('.jdgm-rev__rating');
      var icon = header.querySelector('.jdgm-rev__icon');
      var authorWrap = header.querySelector('.jdgm-rev__author-wrapper');
      var title = content.querySelector('.jdgm-rev__title');
      var body = content.querySelector('.jdgm-rev__body');
      var pics = card.querySelector('.jdgm-rev__pics');

      var shell = document.createElement('div');
      shell.className = 'una-jdgm-card';

      if (rating) {
        var stars = document.createElement('div');
        stars.className = 'una-jdgm-card__stars';
        stars.appendChild(rating);
        shell.appendChild(stars);
      }

      attachJudgemePics(shell, pics);

      var quote = document.createElement('div');
      quote.className = 'una-jdgm-card__quote';
      if (title && title.textContent.trim()) {
        quote.appendChild(title);
      }
      if (body) {
        quote.appendChild(body);
      }
      shell.appendChild(quote);

      if (icon || authorWrap) {
        var foot = document.createElement('div');
        foot.className = 'una-jdgm-card__footer';
        if (icon) foot.appendChild(icon);
        if (authorWrap) foot.appendChild(authorWrap);
        shell.appendChild(foot);
      }

      header.remove();
      content.innerHTML = '';
      content.appendChild(shell);
    });
    hydrateJudgemeReviewPics(document.querySelector('[data-una-reviews-section]'));
  }

  function resetJudgemeReviewTrack() {
    var section = document.querySelector('[data-una-reviews-section]');
    if (!section) return;
    var track = section.querySelector('[data-una-slider-track], .jdgm-rev-widg__reviews');
    if (!track) return;
    track.scrollLeft = 0;
    try { track.dispatchEvent(new Event('scroll')); } catch (err) {}
  }

  function holdWindowScroll(y, ms) {
    var stopAt = Date.now() + (ms || 900);
    function tick() {
      if (Math.abs((window.scrollY || window.pageYOffset || 0) - y) > 1) {
        window.scrollTo(0, y);
      }
      if (Date.now() < stopAt) window.requestAnimationFrame(tick);
    }
    tick();
  }

  function patchJudgemePageJump() {
    if (window.jdgm) {
      jdgm._focusFirstPaginatedItem = function () {};
      var origScrollTo = jdgm.scrollTo;
      if (origScrollTo && !origScrollTo._unaPatched) {
        jdgm.scrollTo = function (target) {
          var node = target && target.jquery ? target[0] : target;
          if (node && node.closest && node.closest('[data-una-reviews-section]')) return;
          return origScrollTo.apply(this, arguments);
        };
        jdgm.scrollTo._unaPatched = true;
      }
      if (jdgm.$) {
        jdgm.$('.una-pdp-reviews .jdgm-review-widget, .una-pdp-reviews .jdgm-rev-widg').data('not-scroll-to', true);
      }
    }
  }

  function judgemeShopDomain() {
    if (window.jdgm && typeof jdgm.shopDomain === 'function') return jdgm.shopDomain();
    if (window.Shopify && Shopify.shop) return Shopify.shop;
    return window.location.hostname;
  }

  function judgemePageParams(section, page) {
    var widget = section.querySelector('.jdgm-review-widget, #judgeme_product_reviews');
    var paginate = section.querySelector('.jdgm-paginate');
    var shop = judgemeShopDomain();
    var params = {
      url: shop,
      shop_domain: shop,
      platform: 'shopify',
      page: String(page),
      per_page: (paginate && paginate.getAttribute('data-per-page')) || '5',
      product_id: widget && (widget.getAttribute('data-id') || widget.getAttribute('data-product-id'))
    };
    if (window.jdgm && typeof jdgm.ajaxParamsFor === 'function' && jdgm.$ && widget) {
      try {
        var extra = jdgm.ajaxParamsFor(jdgm.$(widget));
        Object.keys(extra || {}).forEach(function (key) {
          if (extra[key] != null && extra[key] !== '') params[key] = extra[key];
        });
        params.page = String(page);
      } catch (err) {}
    }
    return params;
  }

  function expandJudgemePager(section) {
    var root = section || document;
    var pager = root.querySelector('.jdgm-paginate');
    if (!pager) return;

    var currentEl = pager.querySelector('.jdgm-curt, [aria-current="true"], [aria-current="page"]');
    var current = parseInt(currentEl && currentEl.getAttribute('data-page'), 10) || 1;
    var last = parseInt(pager.getAttribute('data-una-last'), 10) || 0;
    var lastEl = pager.querySelector('.jdgm-paginate__last-page');
    if (!last) last = parseInt(lastEl && lastEl.getAttribute('data-page'), 10) || 0;
    if (!last) {
      pager.querySelectorAll('.jdgm-paginate__page[data-page]').forEach(function (el) {
        var n = parseInt(el.getAttribute('data-page'), 10) || 0;
        if (n > last) last = n;
      });
    }
    if (!last) {
      var widg = root.querySelector('.jdgm-rev-widg');
      var total = parseInt(widg && widg.getAttribute('data-number-of-reviews'), 10) || 0;
      var per = parseInt(pager.getAttribute('data-per-page'), 10) || 5;
      if (total && per) last = Math.ceil(total / per);
    }
    if (last < 2) {
      pager.style.display = 'none';
      return;
    }
    pager.style.removeProperty('display');

    var windowSize = Math.min(5, last);
    var start = Math.max(1, current - Math.floor((windowSize - 1) / 2));
    var end = Math.min(last, start + windowSize - 1);
    start = Math.max(1, end - windowSize + 1);

    var signature = 'bar:' + current + ':' + start + ':' + end + ':' + last;
    if (pager.getAttribute('data-una-pager') === signature) return;

    function makeLink(page, extra, label, text) {
      var a = document.createElement('a');
      a.className = 'jdgm-paginate__page' + (extra ? ' ' + extra : '');
      a.setAttribute('data-page', String(page));
      a.setAttribute('tabindex', extra && extra.indexOf('is-disabled') !== -1 ? '-1' : '0');
      a.setAttribute('role', 'button');
      if (label) a.setAttribute('aria-label', label);
      if (text) a.textContent = text;
      return a;
    }

    pager.innerHTML = '';
    pager.setAttribute('data-una-last', String(last));

    var bar = document.createElement('div');
    bar.className = 'una-reviews-pager';
    bar.setAttribute('role', 'navigation');
    bar.setAttribute('aria-label', 'Review pages');

    var prev = makeLink(Math.max(1, current - 1), 'jdgm-paginate__prev-page', 'Previous page', '‹');
    if (current <= 1) {
      prev.classList.add('is-disabled');
      prev.setAttribute('aria-disabled', 'true');
      prev.setAttribute('tabindex', '-1');
    }
    bar.appendChild(prev);

    for (var p = start; p <= end; p++) {
      var a = makeLink(p, p === current ? 'jdgm-curt' : '', 'Page ' + p, String(p));
      if (p === current) a.setAttribute('aria-current', 'page');
      bar.appendChild(a);
    }

    var next = makeLink(Math.min(last, current + 1), 'jdgm-paginate__next-page', 'Next page', '›');
    if (current >= last) {
      next.classList.add('is-disabled');
      next.setAttribute('aria-disabled', 'true');
      next.setAttribute('tabindex', '-1');
    }
    bar.appendChild(next);
    pager.appendChild(bar);
    pager.setAttribute('data-una-pager', signature);
  }

  function applyJudgemePageHtml(section, html) {
    var box = document.createElement('div');
    box.innerHTML = html || '';
    var incomingTrack = box.querySelector('.jdgm-rev-widg__reviews');
    var incomingPager = box.querySelector('.jdgm-paginate');
    var track = section.querySelector('.jdgm-rev-widg__reviews');
    var pager = section.querySelector('.jdgm-paginate');
    var cards = (incomingTrack || box).querySelectorAll('.jdgm-rev');

    if (track && incomingTrack) {
      incomingTrack.querySelectorAll('.jdgm-paginate').forEach(function (node) { node.remove(); });
      track.querySelectorAll('.jdgm-paginate').forEach(function (node) { node.remove(); });
      track.innerHTML = incomingTrack.innerHTML;
    } else if (track && cards.length) {
      track.querySelectorAll('.jdgm-paginate').forEach(function (node) { node.remove(); });
      track.innerHTML = '';
      Array.prototype.forEach.call(cards, function (card) {
        track.appendChild(card);
      });
    }
    pullJudgemePagerOut();
    pager = section.querySelector('.jdgm-paginate');
    if (incomingPager) {
      if (pager) pager.innerHTML = incomingPager.innerHTML;
      else {
        var host = (track && track.closest('[data-una-slider]')) || track;
        if (host && host.parentNode) host.parentNode.insertBefore(incomingPager, host.nextSibling);
      }
    }
    expandJudgemePager(section);
    resetJudgemeReviewTrack();
    normalizeJudgemeCards();
    wrapJudgemeReviewTracks();
    initProductSliders();
  }

  function loadJudgemePage(section, page) {
    if (!page || section.getAttribute('data-una-paging') === '1') return;
    var paginate = section.querySelector('.jdgm-paginate');
    var endpoint = (paginate && paginate.getAttribute('data-url')) || 'https://cdn.judge.me/reviews/reviews_for_widget';
    if (window.jdgm && typeof jdgm.toCdnUrl === 'function') endpoint = jdgm.toCdnUrl(endpoint);
    else endpoint = endpoint.replace(/^https?:\/\/[^/]+/, 'https://cdn.judge.me');

    var params = judgemePageParams(section, page);
    var query = Object.keys(params).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    var y = window.scrollY || window.pageYOffset || 0;
    section.setAttribute('data-una-paging', '1');
    holdWindowScroll(y, 1200);

    fetch(endpoint + '?' + query, { credentials: 'omit' }).then(function (res) {
      if (!res.ok) throw new Error('reviews page failed');
      return res.json();
    }).then(function (data) {
      applyJudgemePageHtml(section, data && data.html);
      holdWindowScroll(y, 400);
    }).catch(function () {
      holdWindowScroll(y, 200);
    }).then(function () {
      section.removeAttribute('data-una-paging');
    });
  }

  function initJudgemePagination() {
    var section = document.querySelector('[data-una-reviews-section]');
    if (!section || section.hasAttribute('data-una-paging-init')) return;
    section.setAttribute('data-una-paging-init', '');
    patchJudgemePageJump();

    section.addEventListener('click', function (e) {
      var link = e.target.closest('.jdgm-paginate .jdgm-paginate__page, .jdgm-paginate a, .jdgm-paginate [role="button"]');
      if (!link || !section.contains(link)) return;
      if (link.classList.contains('jdgm-curt') || link.getAttribute('aria-current') === 'true') {
        e.preventDefault();
        return;
      }
      if (link.classList.contains('is-disabled') || link.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }
      var page = link.getAttribute('data-page');
      if (!page) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      loadJudgemePage(section, page);
    }, true);
  }

  function initJudgemeReviewCarousel() {
    forceJudgemeVisible();
    normalizeJudgemeCards();
    wrapJudgemeReviewTracks();
    initProductSliders();
    syncReviewsSectionVisibility();
    initJudgemeWriteReview();
    initJudgemePagination();
    patchJudgemePageJump();
    expandJudgemePager(document.querySelector('[data-una-reviews-section]'));
  }

  function observeJudgemeReviews() {
    var root = document.querySelector('.una-pdp-reviews-apps-wrap, .una-pdp-reviews--judgeme');
    if (!root) return;

    initJudgemeReviewCarousel();

    if (typeof MutationObserver === 'undefined') {
      window.setTimeout(syncReviewsSectionVisibility, 1500);
      return;
    }

    var timer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        initJudgemeReviewCarousel();
        syncReviewsSectionVisibility();
      }, 120);
    });

    observer.observe(root, { childList: true, subtree: true });
    document.addEventListener('jdgm.doneSetup', patchJudgemePageJump);
    window.setTimeout(patchJudgemePageJump, 800);
    window.setTimeout(syncReviewsSectionVisibility, 1500);
    window.setTimeout(syncReviewsSectionVisibility, 3500);
  }

  function suppressThirdPartyPopups() {
    var popup = document.querySelector('[data-una-promo-popup]');
    if (!popup || popup.getAttribute('data-hide-third-party') !== 'true') return;

    var selectors = [
      '[id^="FBpopupFormWrapper"]',
      '[id^="FBbtnPopupWrapper"]',
      '.pxFormGenerator',
      'iframe[src*="formbuilder.hulkapps.com"]',
      '#hulkapps-form-builder-modal',
      '[class*="hulkapps"]',
      'shopify-forms-embed',
      '.shopify-forms-embed',
      '#shopify-forms-root',
      '.needsclick.klaviyo-form',
      '[class*="kl-private"]',
      '#privy-container',
      '.privy-popup-container',
      '.justuno-popup',
      '[id*="omapp"]'
    ].join(',');

    function hideNodes() {
      document.querySelectorAll(selectors).forEach(function (node) {
        if (node.closest('[data-una-promo-popup]')) return;
        node.remove();
      });
    }

    hideNodes();

    if (typeof MutationObserver !== 'undefined') {
      var timer = null;
      var observer = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(hideNodes, 50);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    window.setInterval(hideNodes, 1500);
  }

  function initPromoPopup() {
    suppressThirdPartyPopups();

    var popup = document.querySelector('[data-una-promo-popup]');
    if (!popup) return;

    var storageKey = popup.getAttribute('data-storage-key') || 'una_promo_popup';
    var delay = parseInt(popup.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 3;
    var expiryDays = parseInt(popup.getAttribute('data-expiry-days'), 10);
    if (isNaN(expiryDays)) expiryDays = 7;

    function isDismissed() {
      try {
        var raw = localStorage.getItem(storageKey);
        if (!raw) return false;
        var data = JSON.parse(raw);
        if (data && data.subscribed) return true;
        return data && data.until && Date.now() < data.until;
      } catch (err) {
        return false;
      }
    }

    function cleanPromoSuccessUrl() {
      try {
        var url = new URL(window.location.href);
        if (!url.searchParams.has('promo_subscribed')) return;
        url.searchParams.delete('promo_subscribed');
        var search = url.searchParams.toString();
        var next = url.pathname + (search ? '?' + search : '') + url.hash;
        window.history.replaceState({}, '', next);
      } catch (err) {}
    }

    function promoSuccessFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        if (params.get('promo_subscribed') === '1') return true;
      } catch (err) {}
      var hash = window.location.hash || '';
      return hash.indexOf('UnaPromoPopupForm') !== -1;
    }

    function dismissPopup() {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('una-promo-open');
      try {
        localStorage.setItem(storageKey, JSON.stringify({
          until: Date.now() + expiryDays * 86400000
        }));
      } catch (err) {}
    }

    function openPopup() {
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('una-promo-open');
      var closeBtn = popup.querySelector('.una-promo-popup__close');
      if (closeBtn) closeBtn.focus();
    }

    popup.querySelectorAll('[data-una-promo-close]').forEach(function (el) {
      el.addEventListener('click', dismissPopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) dismissPopup();
    });

    var form = popup.querySelector('.una-promo-popup__form');
    var tagsInput = popup.querySelector('[data-una-promo-tags]');
    var statusEl = form ? form.querySelector('[data-una-promo-status]') : null;
    var successEl = popup.querySelector('[data-una-promo-success]');
    var copyBtn = popup.querySelector('[data-una-promo-copy]');
    var codeEl = popup.querySelector('[data-una-promo-code]');

    function syncPromoTags() {
      if (!tagsInput) return;
      var checked = popup.querySelector('[data-una-promo-pref]:checked');
      var pref = checked ? checked.value : '';
      tagsInput.value = pref
        ? 'newsletter,promo-popup,' + pref
        : 'newsletter,promo-popup';
    }

    function showFormStatus(type, message) {
      if (!statusEl) return;
      statusEl.hidden = !message;
      statusEl.textContent = message || '';
      statusEl.className = 'una-promo-popup__msg una-promo-popup__msg--' + type;
      statusEl.setAttribute('role', type === 'error' ? 'alert' : 'status');
    }

    function showSuccessView() {
      if (form) {
        form.classList.remove('is-submitting');
        form.classList.add('is-success');
      }
      if (successEl) {
        successEl.hidden = false;
        successEl.removeAttribute('hidden');
      }
      if (statusEl) {
        statusEl.hidden = true;
        statusEl.textContent = '';
      }
      var submitBtn = form ? form.querySelector('[type="submit"]') : null;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.removeAttribute('aria-busy');
      }
    }

    function promoSignupSucceeded(response, html) {
      var url = response && response.url ? response.url : '';
      if (url.indexOf('/challenge') !== -1) return false;
      if (response && response.ok) return true;
      if (response && response.redirected && response.status >= 200 && response.status < 400) return true;
      html = html || '';
      if (/form-success|posted_successfully|customer_posted|thank you for subscribing/i.test(html)) return true;
      if (/class=["']errors["']|customer\.errors|already been taken/i.test(html)) return false;
      return !!(response && response.type === 'basic' && response.status === 0);
    }

    function promoSignupErrorMessage(html) {
      html = html || '';
      if (/already been taken|already subscribed/i.test(html)) {
        return 'This email is already subscribed.';
      }
      if (/invalid|enter a valid email/i.test(html)) {
        return 'Please enter a valid email.';
      }
      return 'Something went wrong. Please try again.';
    }

    function copyDiscountCode() {
      var code = codeEl ? String(codeEl.textContent || '').trim() : 'aaryasub10';
      if (!code) return;

      function markCopied() {
        if (!copyBtn) return;
        copyBtn.textContent = 'Copied!';
        copyBtn.classList.add('is-copied');
        window.setTimeout(function () {
          copyBtn.textContent = 'Copy';
          copyBtn.classList.remove('is-copied');
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(markCopied).catch(function () {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
            markCopied();
          } catch (err) {}
          document.body.removeChild(ta);
        });
        return;
      }

      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        markCopied();
      } catch (err) {}
      document.body.removeChild(ta);
    }

    function markSubscribed(email) {
      try {
        localStorage.setItem(storageKey, JSON.stringify({
          until: Date.now() + expiryDays * 86400000,
          subscribed: true,
          email: email || ''
        }));
      } catch (err) {}
    }

    function submitToShopify(event) {
      event.preventDefault();
      syncPromoTags();

      var emailInput = form.querySelector('input[name="contact[email]"]');
      var submitBtn = form.querySelector('[type="submit"]');
      var marketingInput = form.querySelector('[name="contact[accepts_marketing]"]');
      var email = emailInput ? String(emailInput.value || '').trim() : '';

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showFormStatus('error', 'Please enter a valid email.');
        if (emailInput) emailInput.focus();
        return;
      }

      if (marketingInput) marketingInput.value = 'true';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }
      form.classList.add('is-submitting');
      showFormStatus('error', '');

      var formData = new FormData(form);
      if (!formData.get('form_type')) formData.set('form_type', 'customer');
      if (!formData.get('utf8')) formData.set('utf8', '\u2713');
      formData.set('contact[email]', email);
      formData.set('contact[accepts_marketing]', 'true');
      if (tagsInput) formData.set('contact[tags]', tagsInput.value);

      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html,application/xhtml+xml'
        }
      })
        .then(function (response) {
          return response.text().then(function (html) {
            if (!promoSignupSucceeded(response, html)) {
              var err = new Error('signup-failed');
              err.html = html;
              throw err;
            }
            return response;
          });
        })
        .then(function () {
          if (emailInput) emailInput.value = '';
          showSuccessView();
          markSubscribed(email);
        })
        .catch(function (err) {
          form.classList.remove('is-submitting');
          var html = err && err.html ? err.html : '';
          if (/already been taken|already subscribed/i.test(html)) {
            if (emailInput) emailInput.value = '';
            showSuccessView();
            markSubscribed(email);
            return;
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
          showFormStatus('error', promoSignupErrorMessage(html));
          if (emailInput) emailInput.focus();
        });
    }

    if (form) {
      form.addEventListener('submit', submitToShopify);
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', copyDiscountCode);
    }

    var shouldShowSuccess = promoSuccessFromUrl()
      || (form && form.classList.contains('is-success'))
      || (successEl && !successEl.hasAttribute('hidden'));

    if (shouldShowSuccess) {
      showSuccessView();
      openPopup();
      markSubscribed('');
      cleanPromoSuccessUrl();
    } else if (!isDismissed()) {
      window.setTimeout(openPopup, Math.max(0, delay) * 1000);
    }
  }

  function initBannerCarousels(scope) {
    var root = scope || document;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll('[data-una-banner]').forEach(function (banner) {
      if (banner.hasAttribute('data-una-banner-init')) return;
      var track = banner.querySelector('[data-una-banner-track]');
      var slides = Array.prototype.slice.call(banner.querySelectorAll('[data-una-banner-slide]'));
      if (!track || !slides.length) return;
      banner.setAttribute('data-una-banner-init', '');

      function syncBannerRatio() {
        var firstImg = slides[0] && slides[0].querySelector('img');
        if (!firstImg || !firstImg.naturalWidth || !firstImg.naturalHeight) return;
        var ratio = firstImg.naturalWidth + ' / ' + firstImg.naturalHeight;
        banner.style.setProperty('--una-banner-ratio', ratio);
        if (window.matchMedia('(max-width: 768px)').matches) {
          var mobileSource = slides[0].querySelector('source[media*="768"]');
          if (!mobileSource) banner.style.setProperty('--una-banner-ratio-mobile', ratio);
        }
      }
      var firstImg = slides[0] && slides[0].querySelector('img');
      if (firstImg) {
        if (firstImg.complete) syncBannerRatio();
        else firstImg.addEventListener('load', syncBannerRatio);
      }

      var dots = Array.prototype.slice.call(banner.querySelectorAll('[data-una-banner-dot]'));
      var prevBtn = banner.querySelector('[data-una-banner-prev]');
      var nextBtn = banner.querySelector('[data-una-banner-next]');
      var index = 0;
      var timer = null;
      var resumeTimer = null;
      var programmatic = false;
      var autoplay = banner.getAttribute('data-autoplay') === 'true' && slides.length > 1 && !reduced;
      var interval = parseInt(banner.getAttribute('data-interval'), 10) || 5000;
      var drag = { active: false, moved: false, startX: 0, startY: 0, startScroll: 0 };

      function slideWidth() {
        return track.clientWidth || 1;
      }

      function updateUI() {
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }

      function goTo(i, instant) {
        if (!slides.length) return;
        index = ((i % slides.length) + slides.length) % slides.length;
        programmatic = true;
        track.scrollTo({
          left: index * slideWidth(),
          behavior: instant || reduced ? 'auto' : 'smooth'
        });
        updateUI();
        window.setTimeout(function () { programmatic = false; }, 480);
      }

      function stopAuto() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function startAuto() {
        stopAuto();
        if (!autoplay || !document.body.contains(banner)) return;
        if (document.hidden) return;
        timer = window.setInterval(function () {
          if (!document.body.contains(banner)) {
            stopAuto();
            return;
          }
          goTo(index + 1);
        }, interval);
      }

      function bumpAuto() {
        window.clearTimeout(resumeTimer);
        stopAuto();
        resumeTimer = window.setTimeout(startAuto, 900);
      }

      track.addEventListener('scroll', function () {
        if (programmatic) return;
        var next = Math.round(track.scrollLeft / slideWidth());
        if (next !== index && next >= 0 && next < slides.length) {
          index = next;
          updateUI();
        }
        bumpAuto();
      }, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); bumpAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); bumpAuto(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); bumpAuto(); });
      });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); bumpAuto(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); bumpAuto(); }
      });

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        drag.active = true;
        drag.moved = false;
        drag.startX = e.clientX;
        drag.startY = e.clientY;
        drag.startScroll = track.scrollLeft;
        stopAuto();
      });

      window.addEventListener('mousemove', function (e) {
        if (!drag.active) return;
        var dx = e.clientX - drag.startX;
        if (!drag.moved && Math.abs(dx) < 6) return;
        drag.moved = true;
        track.classList.add('is-dragging');
        track.scrollLeft = drag.startScroll - dx;
      });

      window.addEventListener('mouseup', function () {
        if (!drag.active) return;
        drag.active = false;
        track.classList.remove('is-dragging');
        goTo(Math.round(track.scrollLeft / slideWidth()));
        bumpAuto();
        window.setTimeout(function () { drag.moved = false; }, 40);
      });

      track.addEventListener('click', function (e) {
        if (!drag.moved) return;
        var link = e.target.closest('a');
        if (link) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      track.addEventListener('touchstart', stopAuto, { passive: true });
      track.addEventListener('touchend', bumpAuto, { passive: true });

      banner.addEventListener('mouseenter', stopAuto);
      banner.addEventListener('mouseleave', startAuto);
      banner.addEventListener('focusin', stopAuto);
      banner.addEventListener('focusout', function (e) {
        if (!banner.contains(e.relatedTarget)) startAuto();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAuto();
        else startAuto();
      });

      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) startAuto();
          else stopAuto();
        }, { threshold: 0.35 });
        io.observe(banner);
      }

      window.addEventListener('resize', function () {
        syncBannerRatio();
        goTo(index, true);
      });
      updateUI();
      startAuto();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBannerCarousels(event.target);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMobileNav();
    initCartDrawer();
    initCartPage();
    initCollectionInfiniteScroll();
    initThumbs();
    initProductSliders();
    initBannerCarousels();
    initLaunchCountdown();
    initProductGallery();
    initProductVariants();
    initQtyBreaks();
    initProductBundle();
    initShare();
    initPromoPopup();
    observeJudgemeReviews();
    initJudgemeWriteReview();
    initCardSwatches();
  });

  if (document.querySelector('[data-una-promo-popup][data-hide-third-party="true"]')) {
    suppressThirdPartyPopups();
  }
})();
